import { RebateTier } from './types'

export const MARKET_SHARE_THRESHOLD_MEASURED_IN = 'market_share_percent'
export const PURCHASE_VOLUME_THRESHOLD_MEASURED_IN = 'purchase_volume_amount'

export const THRESHOLD_MEASURED_IN_OPTIONS = [
  {
    label: 'Market share, %',
    value: MARKET_SHARE_THRESHOLD_MEASURED_IN
  },
  {
    label: 'Purchase volume, $',
    value: PURCHASE_VOLUME_THRESHOLD_MEASURED_IN
  }
]

export const HOSPITAL_OPTIONS = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No, apply to individual Hospitals',
    value: false
  }
]

export const MAX_REBATE_TIERS = 15

export const EMPTY_REBATE_TIER: RebateTier = {
  uuid: null,
  threshold: null,
  amount: null
}

export const THRESHOLD_LESS_THAN_PREVIOUS_TIER =
  "Threshold can't be less than in the tier above"
